import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { DICTS } from "./dictionaries";
import { config } from "../lib/config";
import { track } from "../lib/analytics";

const I18nCtx = createContext(null);
const KEY = "xwj.lang";

function lookup(dict, path) {
  return path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(KEY);
    return DICTS[saved] ? saved : config.defaultLanguage;
  });
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = useCallback((l) => {
    if (!DICTS[l]) return;
    localStorage.setItem(KEY, l);
    setLangState(l);
    track("language_change", { lang: l });
  }, []);
  const t = useCallback((path) => {
    const v = lookup(DICTS[lang], path);
    return v === undefined ? lookup(DICTS.en, path) ?? path : v;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
